﻿export function parseAutocompleteList(list, data) {
	let li = document.createElement('li')
	li.className = 'lg:col-span-3 text-right';
	let anchor = document.createElement('a');
	anchor.className = 'btn btn-outline-primary inline-block text-sm';
	anchor.href = `/shop?q=${data.query}`;
	anchor.innerText = 'Vedi Tutti'
	li.appendChild(anchor);
	list.appendChild(li);
}

export function parseAutocompleteItem(item, data) {
	item.innerText = '';
	let container = document.createElement('div');
	container.className = 'h-full flex items-center gap-1 border border-solid border-gray-200 base-transition hover:cursor-pointer hover:border-primary';
	let article = data.value;
	let imageUrls = Object.values(article.imageUrls);
	if (imageUrls.length > 0) {
		let img = document.createElement('img');
		img.src = imageUrls[0][0];
		img.className = 'w-24';
		container.appendChild(img);
	} else {
		let img = document.createElement('div');
		img.className = 'h-full bg-secondary text-white text-sm flex justify-center items-center';
		img.style = 'min-width:80px';
		let span = document.createElement('span');
		span.className = 'strike-through';
		span.innerText = 'No Image'
		img.appendChild(span);
		container.appendChild(img);
	}
	let info = document.createElement('div');
	info.className = 'p-1 self-stretch flex flex-col justify-between border-l border-solid border-gray-200';
	let name = document.createElement('h5');
	name.className = 'leading-none text-sm';
	name.innerHTML = article.name;
	info.appendChild(name);

	let price = document.createElement('h6');
	price.className = 'font-bold text-primary text-right';
	if (article.variantPrices.length > 0) {
		price.innerHTML = `€ ${article.variantPrices.filter(p => p.priceType.id === 'web')[0].sellPrice.toFixed(2)}`;
	} else {
		price.innerHTML = `€ ${article.prices.filter(p => p.priceType.id === 'web')[0].sellPrice.toFixed(2)}`;
	}
	
	info.appendChild(price);

	container.appendChild(info);

	item.appendChild(container);
}